const Requests = {
  p01Mst001User: 'role/userservices/{userServices}/user',  // GETメソッド
  p01Mst001UserServices: 'common/userservices',  // GETメソッド
  p01Mst002UserServices: 'role/userservices',  // GETメソッド
  p01Mst002RoleName: 'role/userservices/{userServices}/rolename/{roleName}',  // PUTメソッド
  p01Mst003Information: 'common/information',  // GETメソッド
  // p01Mst003GroupType: 'grouptype',  // GETメソッド
};

export default Requests;